export default __webpack_public_path__ + "static/media/4948.130d5f88.png";